// services/Deliverable.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";

export default class Team extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "team";
    static pluralName = "teams";
    static displayName = "Team";

    constructor() {
        super(`${Team.kind}`,`${Team.singularName}`,`${Team.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.find(id, _query);
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }

    async archiveItem(id) {
        return await this.postAction(`/teams/${id}/archive`);
    }

    async getSummary(id) {
        return await this.action({}, `/teams/${id}/summary`);
    }

    async getHealth(id) {
        return await this.action({}, `/teams/${id}/health`);
    }

    async getTasks(id, query = {}) {
        const queryString = qs.stringify(query, {encodeValuesOnly: true});
        return await this.action(queryString, `/teams/${id}/tasks`);
    }

    async updateMembers(id, data) {
        return await this.postAction(`/teams/${id}/members`, data);
    }
}
